function cov_1h4ixuuzfe() {
  var path = "/codebuild/output/src315236701/src/src/common/store/history.ts";
  var hash = "cea05d3f1747ada407a703ca8db1dc53b947154f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src315236701/src/src/common/store/history.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 31
        },
        end: {
          line: 148,
          column: 2
        }
      },
      "1": {
        start: {
          line: 5,
          column: 18
        },
        end: {
          line: 15,
          column: 5
        }
      },
      "2": {
        start: {
          line: 17,
          column: 28
        },
        end: {
          line: 17,
          column: 45
        }
      },
      "3": {
        start: {
          line: 18,
          column: 28
        },
        end: {
          line: 18,
          column: 61
        }
      },
      "4": {
        start: {
          line: 20,
          column: 45
        },
        end: {
          line: 20,
          column: 50
        }
      },
      "5": {
        start: {
          line: 21,
          column: 12
        },
        end: {
          line: 22,
          column: 28
        }
      },
      "6": {
        start: {
          line: 22,
          column: 16
        },
        end: {
          line: 22,
          column: 28
        }
      },
      "7": {
        start: {
          line: 23,
          column: 12
        },
        end: {
          line: 26,
          column: 14
        }
      },
      "8": {
        start: {
          line: 34,
          column: 12
        },
        end: {
          line: 42,
          column: 15
        }
      },
      "9": {
        start: {
          line: 52,
          column: 12
        },
        end: {
          line: 53,
          column: 23
        }
      },
      "10": {
        start: {
          line: 53,
          column: 16
        },
        end: {
          line: 53,
          column: 23
        }
      },
      "11": {
        start: {
          line: 54,
          column: 12
        },
        end: {
          line: 54,
          column: 42
        }
      },
      "12": {
        start: {
          line: 62,
          column: 43
        },
        end: {
          line: 62,
          column: 47
        }
      },
      "13": {
        start: {
          line: 64,
          column: 12
        },
        end: {
          line: 64,
          column: 47
        }
      },
      "14": {
        start: {
          line: 66,
          column: 12
        },
        end: {
          line: 70,
          column: 13
        }
      },
      "15": {
        start: {
          line: 67,
          column: 16
        },
        end: {
          line: 67,
          column: 39
        }
      },
      "16": {
        start: {
          line: 68,
          column: 16
        },
        end: {
          line: 68,
          column: 42
        }
      },
      "17": {
        start: {
          line: 69,
          column: 16
        },
        end: {
          line: 69,
          column: 34
        }
      },
      "18": {
        start: {
          line: 72,
          column: 23
        },
        end: {
          line: 72,
          column: 32
        }
      },
      "19": {
        start: {
          line: 73,
          column: 12
        },
        end: {
          line: 73,
          column: 64
        }
      },
      "20": {
        start: {
          line: 74,
          column: 12
        },
        end: {
          line: 75,
          column: 29
        }
      },
      "21": {
        start: {
          line: 75,
          column: 16
        },
        end: {
          line: 75,
          column: 29
        }
      },
      "22": {
        start: {
          line: 76,
          column: 12
        },
        end: {
          line: 76,
          column: 22
        }
      },
      "23": {
        start: {
          line: 79,
          column: 12
        },
        end: {
          line: 82,
          column: 13
        }
      },
      "24": {
        start: {
          line: 80,
          column: 16
        },
        end: {
          line: 80,
          column: 37
        }
      },
      "25": {
        start: {
          line: 81,
          column: 16
        },
        end: {
          line: 81,
          column: 23
        }
      },
      "26": {
        start: {
          line: 83,
          column: 12
        },
        end: {
          line: 83,
          column: 32
        }
      },
      "27": {
        start: {
          line: 84,
          column: 26
        },
        end: {
          line: 84,
          column: 44
        }
      },
      "28": {
        start: {
          line: 85,
          column: 12
        },
        end: {
          line: 108,
          column: 13
        }
      },
      "29": {
        start: {
          line: 86,
          column: 33
        },
        end: {
          line: 86,
          column: 100
        }
      },
      "30": {
        start: {
          line: 89,
          column: 16
        },
        end: {
          line: 92,
          column: 17
        }
      },
      "31": {
        start: {
          line: 90,
          column: 20
        },
        end: {
          line: 90,
          column: 38
        }
      },
      "32": {
        start: {
          line: 91,
          column: 20
        },
        end: {
          line: 91,
          column: 40
        }
      },
      "33": {
        start: {
          line: 93,
          column: 16
        },
        end: {
          line: 95,
          column: 17
        }
      },
      "34": {
        start: {
          line: 94,
          column: 20
        },
        end: {
          line: 94,
          column: 38
        }
      },
      "35": {
        start: {
          line: 98,
          column: 16
        },
        end: {
          line: 100,
          column: 17
        }
      },
      "36": {
        start: {
          line: 99,
          column: 20
        },
        end: {
          line: 99,
          column: 47
        }
      },
      "37": {
        start: {
          line: 102,
          column: 16
        },
        end: {
          line: 104,
          column: 17
        }
      },
      "38": {
        start: {
          line: 103,
          column: 20
        },
        end: {
          line: 103,
          column: 74
        }
      },
      "39": {
        start: {
          line: 107,
          column: 16
        },
        end: {
          line: 107,
          column: 35
        }
      },
      "40": {
        start: {
          line: 110,
          column: 12
        },
        end: {
          line: 110,
          column: 29
        }
      },
      "41": {
        start: {
          line: 111,
          column: 12
        },
        end: {
          line: 111,
          column: 25
        }
      },
      "42": {
        start: {
          line: 117,
          column: 12
        },
        end: {
          line: 117,
          column: 44
        }
      },
      "43": {
        start: {
          line: 123,
          column: 12
        },
        end: {
          line: 123,
          column: 44
        }
      },
      "44": {
        start: {
          line: 130,
          column: 28
        },
        end: {
          line: 130,
          column: 45
        }
      },
      "45": {
        start: {
          line: 131,
          column: 38
        },
        end: {
          line: 131,
          column: 42
        }
      },
      "46": {
        start: {
          line: 132,
          column: 24
        },
        end: {
          line: 132,
          column: 72
        }
      },
      "47": {
        start: {
          line: 133,
          column: 12
        },
        end: {
          line: 134,
          column: 23
        }
      },
      "48": {
        start: {
          line: 134,
          column: 16
        },
        end: {
          line: 134,
          column: 23
        }
      },
      "49": {
        start: {
          line: 136,
          column: 24
        },
        end: {
          line: 136,
          column: 51
        }
      },
      "50": {
        start: {
          line: 137,
          column: 12
        },
        end: {
          line: 138,
          column: 36
        }
      },
      "51": {
        start: {
          line: 138,
          column: 16
        },
        end: {
          line: 138,
          column: 36
        }
      },
      "52": {
        start: {
          line: 140,
          column: 25
        },
        end: {
          line: 140,
          column: 65
        }
      },
      "53": {
        start: {
          line: 141,
          column: 12
        },
        end: {
          line: 142,
          column: 23
        }
      },
      "54": {
        start: {
          line: 142,
          column: 16
        },
        end: {
          line: 142,
          column: 23
        }
      },
      "55": {
        start: {
          line: 143,
          column: 12
        },
        end: {
          line: 143,
          column: 43
        }
      },
      "56": {
        start: {
          line: 144,
          column: 12
        },
        end: {
          line: 145,
          column: 29
        }
      },
      "57": {
        start: {
          line: 145,
          column: 16
        },
        end: {
          line: 145,
          column: 29
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 11
          },
          end: {
            line: 5,
            column: 12
          }
        },
        loc: {
          start: {
            line: 5,
            column: 18
          },
          end: {
            line: 15,
            column: 5
          }
        },
        line: 5
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 17,
            column: 17
          },
          end: {
            line: 17,
            column: 18
          }
        },
        loc: {
          start: {
            line: 17,
            column: 28
          },
          end: {
            line: 17,
            column: 45
          }
        },
        line: 17
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 18,
            column: 17
          },
          end: {
            line: 18,
            column: 18
          }
        },
        loc: {
          start: {
            line: 18,
            column: 28
          },
          end: {
            line: 18,
            column: 61
          }
        },
        line: 18
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 19,
            column: 23
          }
        },
        loc: {
          start: {
            line: 19,
            column: 33
          },
          end: {
            line: 27,
            column: 9
          }
        },
        line: 19
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 33,
            column: 8
          },
          end: {
            line: 33,
            column: 9
          }
        },
        loc: {
          start: {
            line: 33,
            column: 16
          },
          end: {
            line: 43,
            column: 9
          }
        },
        line: 33
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        },
        loc: {
          start: {
            line: 51,
            column: 34
          },
          end: {
            line: 55,
            column: 9
          }
        },
        line: 51
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        },
        loc: {
          start: {
            line: 61,
            column: 37
          },
          end: {
            line: 77,
            column: 9
          }
        },
        line: 61
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 78,
            column: 8
          },
          end: {
            line: 78,
            column: 9
          }
        },
        loc: {
          start: {
            line: 78,
            column: 22
          },
          end: {
            line: 112,
            column: 9
          }
        },
        line: 78
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 116,
            column: 8
          },
          end: {
            line: 116,
            column: 9
          }
        },
        loc: {
          start: {
            line: 116,
            column: 21
          },
          end: {
            line: 118,
            column: 9
          }
        },
        line: 116
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 122,
            column: 9
          }
        },
        loc: {
          start: {
            line: 122,
            column: 21
          },
          end: {
            line: 124,
            column: 9
          }
        },
        line: 122
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 129,
            column: 8
          },
          end: {
            line: 129,
            column: 9
          }
        },
        loc: {
          start: {
            line: 129,
            column: 34
          },
          end: {
            line: 146,
            column: 9
          }
        },
        line: 129
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 22,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 22,
            column: 28
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 21
      },
      "1": {
        loc: {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 53,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 53,
            column: 23
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 52
      },
      "2": {
        loc: {
          start: {
            line: 66,
            column: 12
          },
          end: {
            line: 70,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 12
          },
          end: {
            line: 70,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 66
      },
      "3": {
        loc: {
          start: {
            line: 74,
            column: 12
          },
          end: {
            line: 75,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 12
          },
          end: {
            line: 75,
            column: 29
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 74
      },
      "4": {
        loc: {
          start: {
            line: 79,
            column: 12
          },
          end: {
            line: 82,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 12
          },
          end: {
            line: 82,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 79
      },
      "5": {
        loc: {
          start: {
            line: 86,
            column: 82
          },
          end: {
            line: 86,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 86,
            column: 82
          },
          end: {
            line: 86,
            column: 92
          }
        }, {
          start: {
            line: 86,
            column: 96
          },
          end: {
            line: 86,
            column: 98
          }
        }],
        line: 86
      },
      "6": {
        loc: {
          start: {
            line: 89,
            column: 16
          },
          end: {
            line: 92,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 89,
            column: 16
          },
          end: {
            line: 92,
            column: 17
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 89
      },
      "7": {
        loc: {
          start: {
            line: 93,
            column: 16
          },
          end: {
            line: 95,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 16
          },
          end: {
            line: 95,
            column: 17
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 93
      },
      "8": {
        loc: {
          start: {
            line: 98,
            column: 16
          },
          end: {
            line: 100,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 98,
            column: 16
          },
          end: {
            line: 100,
            column: 17
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 98
      },
      "9": {
        loc: {
          start: {
            line: 102,
            column: 16
          },
          end: {
            line: 104,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 16
          },
          end: {
            line: 104,
            column: 17
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 102
      },
      "10": {
        loc: {
          start: {
            line: 132,
            column: 24
          },
          end: {
            line: 132,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 132,
            column: 34
          },
          end: {
            line: 132,
            column: 45
          }
        }, {
          start: {
            line: 132,
            column: 50
          },
          end: {
            line: 132,
            column: 71
          }
        }],
        line: 132
      },
      "11": {
        loc: {
          start: {
            line: 133,
            column: 12
          },
          end: {
            line: 134,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 133,
            column: 12
          },
          end: {
            line: 134,
            column: 23
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 133
      },
      "12": {
        loc: {
          start: {
            line: 136,
            column: 24
          },
          end: {
            line: 136,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 136,
            column: 33
          },
          end: {
            line: 136,
            column: 39
          }
        }, {
          start: {
            line: 136,
            column: 42
          },
          end: {
            line: 136,
            column: 51
          }
        }],
        line: 136
      },
      "13": {
        loc: {
          start: {
            line: 137,
            column: 12
          },
          end: {
            line: 138,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 137,
            column: 12
          },
          end: {
            line: 138,
            column: 36
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 137
      },
      "14": {
        loc: {
          start: {
            line: 141,
            column: 12
          },
          end: {
            line: 142,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 141,
            column: 12
          },
          end: {
            line: 142,
            column: 23
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 141
      },
      "15": {
        loc: {
          start: {
            line: 144,
            column: 12
          },
          end: {
            line: 145,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 144,
            column: 12
          },
          end: {
            line: 145,
            column: 29
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 144
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/codebuild/output/src315236701/src/src/common/store/history.ts",
      sourceRoot: "",
      sources: ["/codebuild/output/src315236701/src/node_modules/vue-cli-plugin-quasar/lib/loader.js.transform-quasar-imports.js!/codebuild/output/src315236701/src/src/common/store/history.ts"],
      names: [],
      mappings: "AAAA,uDAAuD;AACvD,OAAO,EAAE,MAAM,EAAE,MAAM,QAAQ,CAAC;AAChC,OAAO,EAAE,WAAW,EAAE,MAAM,OAAO,CAAC;AAOpC,MAAM,CAAC,MAAM,eAAe,GAAG,WAAW,CAAC,SAAS,EAAE;IACpD,KAAK,EAAE,GAAG,EAAE,CAAC,CAAC;QACZ,GAAG,EAAE,EAAE;QACP,QAAQ,EAAE,EAAE;QACZ,IAAI,EAAE,EAAE;QACR,OAAO,EAAE,CAAC;QACV,SAAS,EAAE,CAAC;QACZ,KAAK,EAAE,EAAE;QACT,OAAO,EAAE,EAAE;QACX,OAAO,EAAE,KAAK;QACd,aAAa,EAAE,KAAK;KACrB,CAAC;IAEF,OAAO,EAAE;QACP,OAAO,EAAE,CAAC,KAAK,EAAW,EAAE,CAAC,KAAK,CAAC,OAAO,GAAG,CAAC;QAC9C,OAAO,EAAE,CAAC,KAAK,EAAW,EAAE,CAAC,KAAK,CAAC,OAAO,GAAG,KAAK,CAAC,IAAI,CAAC,MAAM;QAC9D,YAAY,EAAE,CAAC,KAAK,EAAE,EAAE;YACtB,MAAM,EAAE,IAAI,EAAE,OAAO,EAAE,KAAK,EAAE,GAAG,KAAK,CAAC;YAEvC,IAAI,OAAO,KAAK,CAAC;gBAAE,OAAO,IAAI,CAAC;YAE/B,OAAO;gBACL,OAAO,EAAE,IAAI,CAAC,OAAO,GAAG,CAAC,CAAC;gBAC1B,IAAI,EAAE,KAAK,CAAC,OAAO,GAAG,CAAC,CAAC;aACzB,CAAC;QACJ,CAAC;KACF;IAED,OAAO,EAAE;QACP;;WAEG;QACH,KAAK;YACH,IAAI,CAAC,MAAM,CAAC;gBACV,IAAI,EAAE,EAAE;gBACR,OAAO,EAAE,CAAC;gBACV,SAAS,EAAE,CAAC;gBACZ,KAAK,EAAE,EAAE;gBACT,OAAO,EAAE,EAAE;gBACX,OAAO,EAAE,KAAK;gBACd,aAAa,EAAE,KAAK;aACrB,CAAC,CAAC;QACL,CAAC;QAED;;;;;;WAMG;QACH,UAAU,CAAC,IAAY,EAAE,OAAiB;YACxC,IAAI,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC;gBAAE,OAAO;YAChC,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC,GAAG,OAAO,CAAC;QAChC,CAAC;QAED;;;;WAIG;QACH,KAAK,CAAC,OAAO,CAAC,IAAY,EAAE,GAAG,IAAI;YACjC,MAAM,EAAE,IAAI,EAAE,OAAO,EAAE,GAAG,EAAE,GAAG,IAAI,CAAC;YACpC,2CAA2C;YAC3C,IAAI,CAAC,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,EAAE,OAAO,CAAC,CAAC;YAEnC,6DAA6D;YAC7D,IAAI,IAAI,CAAC,MAAM,IAAI,GAAG,EAAE;gBACtB,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC,EAAE,CAAC,CAAC,CAAC;gBACvB,IAAI,CAAC,OAAO,CAAC,MAAM,CAAC,CAAC,EAAE,CAAC,CAAC,CAAC;gBAC1B,IAAI,CAAC,OAAO,IAAI,CAAC,CAAC;aACnB;YAED,wCAAwC;YACxC,MAAM,EAAE,GAAG,MAAM,CAAC,CAAC,CAAC,CAAC;YACrB,IAAI,CAAC,KAAK,CAAC,IAAI,CAAC,EAAE,IAAI,EAAE,IAAI,EAAE,GAAG,EAAE,SAAS,EAAE,EAAE,EAAE,CAAC,CAAC;YACpD,IAAI,CAAC,IAAI,CAAC,OAAO;gBAAE,IAAI,CAAC,KAAK,EAAE,CAAC;YAChC,OAAO,EAAE,CAAC;QACZ,CAAC;QAED,KAAK,CAAC,KAAK;YACT,IAAI,IAAI,CAAC,KAAK,CAAC,MAAM,KAAK,CAAC,EAAE;gBAC3B,IAAI,CAAC,OAAO,GAAG,KAAK,CAAC;gBACrB,OAAO;aACR;YAED,IAAI,CAAC,OAAO,GAAG,IAAI,CAAC;YACpB,MAAM,KAAK,GAAG,IAAI,CAAC,KAAK,CAAC,KAAK,EAAE,CAAC;YAEjC,IAAI;gBACF,MAAM,QAAQ,GAAG,MAAM,IAAI,CAAC,QAAQ,CAAC,KAAK,CAAC,IAAI,CAAC,EAAE,CAAC,KAAK,CAAC,GAAG,CAAC,CAAC,GAAG,CAAC,KAAK,CAAC,IAAI,IAAI,EAAE,CAAC,CAAC,CAAC;gBAErF,2DAA2D;gBAC3D,6DAA6D;gBAC7D,IAAI,KAAK,CAAC,GAAG,KAAK,MAAM,EAAE;oBACxB,IAAI,CAAC,OAAO,IAAI,CAAC,CAAC;oBAClB,IAAI,CAAC,SAAS,IAAI,CAAC,CAAC;iBACrB;gBAED,IAAI,KAAK,CAAC,GAAG,KAAK,SAAS,EAAE;oBAC3B,IAAI,CAAC,OAAO,IAAI,CAAC,CAAC;iBACnB;gBAED,qEAAqE;gBACrE,sCAAsC;gBACtC,IAAI,KAAK,CAAC,IAAI,EAAE;oBACd,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,IAAI,CAAC,CAAC;iBAC5B;gBAED,kFAAkF;gBAClF,IAAI,KAAK,CAAC,EAAE,EAAE;oBACZ,IAAI,CAAC,OAAO,CAAC,IAAI,CAAC,EAAE,EAAE,EAAE,KAAK,CAAC,EAAE,EAAE,MAAM,EAAE,QAAQ,EAAE,CAAC,CAAC;iBACvD;aACF;YAAC,OAAO,GAAG,EAAE;gBACZ,OAAO,CAAC,KAAK,CAAC,GAAG,CAAC,CAAC;aACpB;YAED,8DAA8D;YAC9D,MAAM,QAAQ,EAAE,CAAC;YAEjB,IAAI,CAAC,KAAK,EAAE,CAAC;QACf,CAAC;QAED;;WAEG;QACH,KAAK,CAAC,IAAI;YACR,OAAO,IAAI,CAAC,WAAW,CAAC,MAAM,CAAC,CAAC;QAClC,CAAC;QAED;;WAEG;QACH,KAAK,CAAC,IAAI;YACR,OAAO,IAAI,CAAC,WAAW,CAAC,MAAM,CAAC,CAAC;QAClC,CAAC;QAED;;;WAGG;QACH,KAAK,CAAC,WAAW,CAAC,MAAuB;YACvC,MAAM,MAAM,GAAG,CAAC,MAAM,KAAK,MAAM,CAAC,CAAC;YACnC,MAAM,EAAE,IAAI,EAAE,OAAO,EAAE,GAAG,IAAI,CAAC;YAC/B,MAAM,GAAG,GAAG,MAAM,CAAC,CAAC,CAAC,CAAC,OAAO,GAAG,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,OAAO,GAAG,IAAI,CAAC,MAAM,CAAC,CAAC;YAE7D,IAAI,CAAC,GAAG;gBAAE,OAAO;YAEjB,0DAA0D;YAC1D,MAAM,GAAG,GAAG,MAAM,CAAC,CAAC,CAAC,MAAM,CAAC,CAAC,CAAC,SAAS,CAAC;YACxC,IAAI,GAAG,KAAK,MAAM;gBAAE,IAAI,CAAC,SAAS,IAAI,CAAC,CAAC;YAExC,4CAA4C;YAC5C,MAAM,IAAI,GAAG,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,OAAO,GAAG,IAAI,CAAC,SAAS,CAAC,CAAC;YACtD,IAAI,CAAC,IAAI;gBAAE,OAAO;YAElB,IAAI,CAAC,KAAK,CAAC,IAAI,CAAC,EAAE,IAAI,EAAE,GAAG,EAAE,CAAC,CAAC;YAC/B,IAAI,CAAC,IAAI,CAAC,OAAO;gBAAE,IAAI,CAAC,KAAK,EAAE,CAAC;QAClC,CAAC;KACF;CACF,CAAC,CAAC;AAEH,eAAe,eAAe,CAAC",
      sourcesContent: ["/* eslint-disable @typescript-eslint/no-explicit-any */\nimport { nanoid } from 'nanoid';\nimport { defineStore } from 'pinia';\n\ninterface ICommand {\n  execute: ((...args: any[]) => void) | any;\n  undo: (() => void) | any;\n}\n\nexport const useHistoryStore = defineStore('history', {\n  state: () => ({\n    max: 10,\n    commands: {},\n    list: [],\n    current: 0,\n    undoCount: 0,\n    queue: [],\n    results: [],\n    running: false,\n    historyFreeze: false,\n  }),\n\n  getters: {\n    canUndo: (state): boolean => state.current > 0,\n    canRedo: (state): boolean => state.current < state.list.length,\n    currentValue: (state) => {\n      const { list, current, queue } = state;\n\n      if (current === 0) return null;\n\n      return {\n        command: list[current - 1],\n        data: queue[current - 1],\n      };\n    },\n  },\n\n  actions: {\n    /**\n     * Reset the store values but not the actions\n     */\n    reset() {\n      this.$patch({\n        list: [],\n        current: 0,\n        undoCount: 0,\n        queue: [],\n        results: [],\n        running: false,\n        historyFreeze: false,\n      });\n    },\n\n    /**\n     * Add commands to use for undo/redo\n     * inspiration http://blog.danielherzog.es/2017-01-04-javascript-command-pattern/\n     * && https://github.com/yassilah/pinia-plugin-history/blob/main/src/index.ts\n     * @param name => the command name\n     * @param command => the commands should have an undo/redo function\n     */\n    addCommand(name: string, command: ICommand) {\n      if (this.commands[name]) return;\n      this.commands[name] = command;\n    },\n\n    /**\n     * Execute a given command\n     * @param name => the command name\n     * @param args => all other arguments to pass into the command\n     */\n    async execute(name: string, ...args) {\n      const { list, current, max } = this;\n      // remove any items after the current index\n      this.list = list.slice(0, current);\n\n      // if we hit the max amount of history remove the last action\n      if (list.length >= max) {\n        this.list.splice(0, 1);\n        this.results.splice(0, 1);\n        this.current -= 1;\n      }\n\n      // add the command and args to the queue\n      const id = nanoid(5);\n      this.queue.push({ name, args, cmd: 'execute', id });\n      if (!this.running) this.flush();\n      return id;\n    },\n\n    async flush() {\n      if (this.queue.length === 0) {\n        this.running = false;\n        return;\n      }\n\n      this.running = true;\n      const entry = this.queue.shift();\n\n      try {\n        const response = await this.commands[entry.name]?.[entry.cmd](...(entry.args || []));\n\n        // decrease the current count and undo count when completed\n        // this keeps the undo and redo actions in sync with the list\n        if (entry.cmd === 'undo') {\n          this.current -= 1;\n          this.undoCount -= 1;\n        }\n\n        if (entry.cmd === 'execute') {\n          this.current += 1;\n        }\n\n        // only add the command name to the list if this is the first trigger\n        // only happens when args are provided\n        if (entry.args) {\n          this.list.push(entry.name);\n        }\n\n        // add the results to the list if needed by the action calling the history command\n        if (entry.id) {\n          this.results.push({ id: entry.id, result: response });\n        }\n      } catch (err) {\n        console.error(err);\n      }\n\n      // just wait for next vue update if there is any store updates\n      await nextTick();\n\n      this.flush();\n    },\n\n    /**\n     * Redo the last undone command\n     */\n    async redo() {\n      return this.stackMethod('redo');\n    },\n\n    /**\n     * Undo the last command\n     */\n    async undo() {\n      return this.stackMethod('undo');\n    },\n\n    /**\n     * Undo/redo stack method\n     * @param method => undo or redo string\n     */\n    async stackMethod(method: 'undo' | 'redo') {\n      const isUndo = (method === 'undo');\n      const { list, current } = this;\n      const can = isUndo ? (current > 0) : (current < list.length);\n\n      if (!can) return;\n\n      // increase undo count to keep in sync with the list items\n      const cmd = isUndo ? 'undo' : 'execute';\n      if (cmd === 'undo') this.undoCount += 1;\n\n      // Move back, and undo the previous command.\n      const name = this.list[this.current - this.undoCount];\n      if (!name) return;\n\n      this.queue.push({ name, cmd });\n      if (!this.running) this.flush();\n    },\n  },\n});\n\nexport default useHistoryStore;\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "cea05d3f1747ada407a703ca8db1dc53b947154f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1h4ixuuzfe = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1h4ixuuzfe();
import "core-js/modules/es.array.push.js";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { nanoid } from 'nanoid';
import { defineStore } from 'pinia';
export const useHistoryStore = (cov_1h4ixuuzfe().s[0]++, defineStore('history', {
  state: () => {
    cov_1h4ixuuzfe().f[0]++;
    cov_1h4ixuuzfe().s[1]++;
    return {
      max: 10,
      commands: {},
      list: [],
      current: 0,
      undoCount: 0,
      queue: [],
      results: [],
      running: false,
      historyFreeze: false
    };
  },
  getters: {
    canUndo: state => {
      cov_1h4ixuuzfe().f[1]++;
      cov_1h4ixuuzfe().s[2]++;
      return state.current > 0;
    },
    canRedo: state => {
      cov_1h4ixuuzfe().f[2]++;
      cov_1h4ixuuzfe().s[3]++;
      return state.current < state.list.length;
    },
    currentValue: state => {
      cov_1h4ixuuzfe().f[3]++;
      const {
        list,
        current,
        queue
      } = (cov_1h4ixuuzfe().s[4]++, state);
      cov_1h4ixuuzfe().s[5]++;
      if (current === 0) {
        cov_1h4ixuuzfe().b[0][0]++;
        cov_1h4ixuuzfe().s[6]++;
        return null;
      } else {
        cov_1h4ixuuzfe().b[0][1]++;
      }
      cov_1h4ixuuzfe().s[7]++;
      return {
        command: list[current - 1],
        data: queue[current - 1]
      };
    }
  },
  actions: {
    /**
     * Reset the store values but not the actions
     */
    reset() {
      cov_1h4ixuuzfe().f[4]++;
      cov_1h4ixuuzfe().s[8]++;
      this.$patch({
        list: [],
        current: 0,
        undoCount: 0,
        queue: [],
        results: [],
        running: false,
        historyFreeze: false
      });
    },
    /**
     * Add commands to use for undo/redo
     * inspiration http://blog.danielherzog.es/2017-01-04-javascript-command-pattern/
     * && https://github.com/yassilah/pinia-plugin-history/blob/main/src/index.ts
     * @param name => the command name
     * @param command => the commands should have an undo/redo function
     */
    addCommand(name, command) {
      cov_1h4ixuuzfe().f[5]++;
      cov_1h4ixuuzfe().s[9]++;
      if (this.commands[name]) {
        cov_1h4ixuuzfe().b[1][0]++;
        cov_1h4ixuuzfe().s[10]++;
        return;
      } else {
        cov_1h4ixuuzfe().b[1][1]++;
      }
      cov_1h4ixuuzfe().s[11]++;
      this.commands[name] = command;
    },
    /**
     * Execute a given command
     * @param name => the command name
     * @param args => all other arguments to pass into the command
     */
    async execute(name, ...args) {
      cov_1h4ixuuzfe().f[6]++;
      const {
        list,
        current,
        max
      } = (cov_1h4ixuuzfe().s[12]++, this);
      // remove any items after the current index
      cov_1h4ixuuzfe().s[13]++;
      this.list = list.slice(0, current);
      // if we hit the max amount of history remove the last action
      cov_1h4ixuuzfe().s[14]++;
      if (list.length >= max) {
        cov_1h4ixuuzfe().b[2][0]++;
        cov_1h4ixuuzfe().s[15]++;
        this.list.splice(0, 1);
        cov_1h4ixuuzfe().s[16]++;
        this.results.splice(0, 1);
        cov_1h4ixuuzfe().s[17]++;
        this.current -= 1;
      } else {
        cov_1h4ixuuzfe().b[2][1]++;
      }
      // add the command and args to the queue
      const id = (cov_1h4ixuuzfe().s[18]++, nanoid(5));
      cov_1h4ixuuzfe().s[19]++;
      this.queue.push({
        name,
        args,
        cmd: 'execute',
        id
      });
      cov_1h4ixuuzfe().s[20]++;
      if (!this.running) {
        cov_1h4ixuuzfe().b[3][0]++;
        cov_1h4ixuuzfe().s[21]++;
        this.flush();
      } else {
        cov_1h4ixuuzfe().b[3][1]++;
      }
      cov_1h4ixuuzfe().s[22]++;
      return id;
    },
    async flush() {
      cov_1h4ixuuzfe().f[7]++;
      cov_1h4ixuuzfe().s[23]++;
      if (this.queue.length === 0) {
        cov_1h4ixuuzfe().b[4][0]++;
        cov_1h4ixuuzfe().s[24]++;
        this.running = false;
        cov_1h4ixuuzfe().s[25]++;
        return;
      } else {
        cov_1h4ixuuzfe().b[4][1]++;
      }
      cov_1h4ixuuzfe().s[26]++;
      this.running = true;
      const entry = (cov_1h4ixuuzfe().s[27]++, this.queue.shift());
      cov_1h4ixuuzfe().s[28]++;
      try {
        const response = (cov_1h4ixuuzfe().s[29]++, await this.commands[entry.name]?.[entry.cmd](...((cov_1h4ixuuzfe().b[5][0]++, entry.args) || (cov_1h4ixuuzfe().b[5][1]++, []))));
        // decrease the current count and undo count when completed
        // this keeps the undo and redo actions in sync with the list
        cov_1h4ixuuzfe().s[30]++;
        if (entry.cmd === 'undo') {
          cov_1h4ixuuzfe().b[6][0]++;
          cov_1h4ixuuzfe().s[31]++;
          this.current -= 1;
          cov_1h4ixuuzfe().s[32]++;
          this.undoCount -= 1;
        } else {
          cov_1h4ixuuzfe().b[6][1]++;
        }
        cov_1h4ixuuzfe().s[33]++;
        if (entry.cmd === 'execute') {
          cov_1h4ixuuzfe().b[7][0]++;
          cov_1h4ixuuzfe().s[34]++;
          this.current += 1;
        } else {
          cov_1h4ixuuzfe().b[7][1]++;
        }
        // only add the command name to the list if this is the first trigger
        // only happens when args are provided
        cov_1h4ixuuzfe().s[35]++;
        if (entry.args) {
          cov_1h4ixuuzfe().b[8][0]++;
          cov_1h4ixuuzfe().s[36]++;
          this.list.push(entry.name);
        } else {
          cov_1h4ixuuzfe().b[8][1]++;
        }
        // add the results to the list if needed by the action calling the history command
        cov_1h4ixuuzfe().s[37]++;
        if (entry.id) {
          cov_1h4ixuuzfe().b[9][0]++;
          cov_1h4ixuuzfe().s[38]++;
          this.results.push({
            id: entry.id,
            result: response
          });
        } else {
          cov_1h4ixuuzfe().b[9][1]++;
        }
      } catch (err) {
        cov_1h4ixuuzfe().s[39]++;
        console.error(err);
      }
      // just wait for next vue update if there is any store updates
      cov_1h4ixuuzfe().s[40]++;
      await nextTick();
      cov_1h4ixuuzfe().s[41]++;
      this.flush();
    },
    /**
     * Redo the last undone command
     */
    async redo() {
      cov_1h4ixuuzfe().f[8]++;
      cov_1h4ixuuzfe().s[42]++;
      return this.stackMethod('redo');
    },
    /**
     * Undo the last command
     */
    async undo() {
      cov_1h4ixuuzfe().f[9]++;
      cov_1h4ixuuzfe().s[43]++;
      return this.stackMethod('undo');
    },
    /**
     * Undo/redo stack method
     * @param method => undo or redo string
     */
    async stackMethod(method) {
      cov_1h4ixuuzfe().f[10]++;
      const isUndo = (cov_1h4ixuuzfe().s[44]++, method === 'undo');
      const {
        list,
        current
      } = (cov_1h4ixuuzfe().s[45]++, this);
      const can = (cov_1h4ixuuzfe().s[46]++, isUndo ? (cov_1h4ixuuzfe().b[10][0]++, current > 0) : (cov_1h4ixuuzfe().b[10][1]++, current < list.length));
      cov_1h4ixuuzfe().s[47]++;
      if (!can) {
        cov_1h4ixuuzfe().b[11][0]++;
        cov_1h4ixuuzfe().s[48]++;
        return;
      } else {
        cov_1h4ixuuzfe().b[11][1]++;
      }
      // increase undo count to keep in sync with the list items
      const cmd = (cov_1h4ixuuzfe().s[49]++, isUndo ? (cov_1h4ixuuzfe().b[12][0]++, 'undo') : (cov_1h4ixuuzfe().b[12][1]++, 'execute'));
      cov_1h4ixuuzfe().s[50]++;
      if (cmd === 'undo') {
        cov_1h4ixuuzfe().b[13][0]++;
        cov_1h4ixuuzfe().s[51]++;
        this.undoCount += 1;
      } else {
        cov_1h4ixuuzfe().b[13][1]++;
      }
      // Move back, and undo the previous command.
      const name = (cov_1h4ixuuzfe().s[52]++, this.list[this.current - this.undoCount]);
      cov_1h4ixuuzfe().s[53]++;
      if (!name) {
        cov_1h4ixuuzfe().b[14][0]++;
        cov_1h4ixuuzfe().s[54]++;
        return;
      } else {
        cov_1h4ixuuzfe().b[14][1]++;
      }
      cov_1h4ixuuzfe().s[55]++;
      this.queue.push({
        name,
        cmd
      });
      cov_1h4ixuuzfe().s[56]++;
      if (!this.running) {
        cov_1h4ixuuzfe().b[15][0]++;
        cov_1h4ixuuzfe().s[57]++;
        this.flush();
      } else {
        cov_1h4ixuuzfe().b[15][1]++;
      }
    }
  }
}));
export default useHistoryStore;